import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {Checkbox} from "antd";
import {ModalForm} from "~/components";
import {NumberField} from "~/components/Forms";

/**
 * Modal cấu hình & bắt đầu một lần crawl. Cấu hình thuộc TỪNG lần crawl (không lưu ở
 * project), mặc định kế thừa lần crawl trước. Dùng ModalForm + hệ thống Form chuẩn.
 */
function RunCrawlForm({open, submitting, defaultValues, onCancel, onSubmit}) {

	const {control, handleSubmit, reset} = useForm({
		defaultValues: {
			max_depth: 3,
			max_pages: 100,
			delay_ms: 500,
			respect_robots: true,
			...defaultValues,
		},
	});

	useEffect(() => {
		if (open) {
			reset({max_depth: 3, max_pages: 100, delay_ms: 500, respect_robots: true, ...defaultValues});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-play"
			title="Chạy crawl"
			subtitle="Cấu hình phạm vi crawl cho lần chạy này"
			onCancel={onCancel}
			onOk={handleSubmit(onSubmit)}
			okText="Bắt đầu crawl"
			loading={submitting}
		>
			<Controller control={control} name="max_depth" render={({field}) => (
				<NumberField label="Độ sâu tối đa (click từ trang chủ)" min={0} max={10} {...field} />
			)} />
			<Controller control={control} name="max_pages" render={({field}) => (
				<NumberField label="Số trang tối đa" min={1} max={2000} {...field} />
			)} />
			<Controller control={control} name="delay_ms" render={({field}) => (
				<NumberField label="Delay giữa các request (ms)" min={0} max={10000} step={100} {...field} />
			)} />
			<Controller control={control} name="respect_robots" render={({field}) => (
				<div className="form-group">
					<Checkbox checked={!!field.value} onChange={(e) => field.onChange(e.target.checked)}>
						Tôn trọng robots.txt (Disallow + Crawl-delay)
					</Checkbox>
				</div>
			)} />
		</ModalForm>
	);
}

export default RunCrawlForm;
